import { Component, inject, input } from '@angular/core';
import { FormatPipe } from '@app/pipes/format.pipe';
import { TextService } from '@app/services/text/text.service';

@Component({
  selector: 'afcu-banner',
  standalone: true,
  imports: [],
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.css'
})
export class BannerComponent {

  state = input.required<'error' | 'information' | 'success' | 'warning' | 'alert' >()
  content = input.required<BannerType>()

  serviceName:string = ""

  protected textService = inject( TextService );

  get Image() {
    return `/icons/banner/${this.state()}.svg`
  }

}
